import {Component, Input} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {Lookups, Race, Waypoint} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {waypointTypeIcons} from "../../model/waypoint-type-icons";

@Component({
  selector: 'app-control-points-table',
  templateUrl: './control-points-table.component.html',
  styleUrls: ['./control-points-table.component.scss']
})
export class ControlPointsTableComponent extends AbstractComponent {
  @Input({required: true}) controlPointsList: Waypoint[] = [];
  @Input({required: true}) race?: Race;
  @Input({required: true}) languages: Lookups[] = [];

  waypointTypeIcons: { [key: number]: string } = waypointTypeIcons;


  constructor(public translocoService: TranslocoService) {
    super();
  }

}
